// src/belediye/components/tasks/GorevListeIskeleti.js
// FAZ-58 — SEKME + ŞERİT. "Görev Ata" ve "Görevlerim" sayfalarının ortak gövdesi.
//
// NE DEĞİŞTİ (FAZ-57 → FAZ-58) ve NİYE:
//   • FAZ-57'de solda ACİLİYET BANTLARI, sağda dikkat şeridi vardı. İkisi AYNI
//     işleri gösteriyordu: gecikmiş bir iş hem sol listenin "Gecikenler" bandında
//     hem sağdaki "Süresi geçenler" kartındaydı. Dahası gecikenler uzayınca
//     listenin ilk ekranını tamamen doldurup diğer işleri aşağı itiyordu.
//   • Çözüm: bant BAŞLIKLARI kalktı, yerine SEKME geri geldi. Sekme listenin
//     hangi kümeye baktığını söyler; sol taraf artık tek bir düz liste.
//   • Sağdaki şerit HER ZAMAN ÜÇ kart taşır ve İÇERİĞİ SEKMEYE GÖRE DEĞİŞİR:
//     sıra gecikenler → onay bekleyenler → yakındakiler. Hangi sekmedeysen o
//     kart şeritten düşer (solda zaten tam listesi var) ve yerine "yeni gelenler"
//     gelir. Böylece aynı iş ekranda İKİ KEZ görünmez.
//   • Şerit kartları da listenin arama+filtre daraltmasını alır → kartın rozeti
//     ile sekmenin sayacı ve listedeki satır sayısı BİRBİRİNİ TUTAR.
//
// Yerleşim:
//   ≥1180px  → sol liste %68 / sağ şerit %32; şerit BAŞLIK BARININ ALTINA
//              yapışır (sayfa kaysa da yerinde durur, barın altına girmez)
//   780-1179 → şerit listenin ÜSTÜNDE yan yana üç kart (tablet)
//   <780px   → şerit üstte tek sütun, kart başına 2 madde (mobil)

import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckCircleIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  HandThumbUpIcon,
  InboxStackIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";

import PageHeader from "../utils/PageHeader";
import SearchBox from "../utils/SearchBox";
import FilterSheet from "../utils/FilterSheet";
import Pagination from "../utils/Pagination";
import {
  fetchCountersThunk,
  fetchTasksThunk,
  selectTaskCounters,
  selectTaskList,
} from "../../redux/slices/internalTasksSlice";
import { EmptyState } from "./GorevBits";
import GorevSatiri from "./GorevSatiri";
import GorevDikkatSeridi from "./GorevDikkatSeridi";
import "./gorev.css";

const PAGE_SIZE = 25;

const ACIK_STATULER = "yeni,devam_ediyor,geri_bildirim_bekliyor,onay_bekliyor";

// ── SEKMELER ────────────────────────────────────────────────────────────
// FAZ-59: sekmeler artık BİRBİRİNİ DIŞLAR. FAZ-58'de ilk sekme "Açık" idi ve
// diğer üçünü de kapsıyordu — kullanıcı haklı olarak "gecikenler zaten kendi
// sekmesinde, burada niye yine var" dedi. İlk sekme artık ARTAN kümedir:
// kapanmamış ama gecikmemiş, onayda olmayan, termini de yakın olmayan işler.
//
//   Yeni ⊎ Onay Bekleyen ⊎ Geciken ⊎ Yakındakiler ⊎ Tamamlanan = her görev
//
// Kümeyi BACKEND tanımlar (`kume` parametresi → selectors.bucket_q); frontend
// tarih matematiği yapmaz, sayaç ile liste sapamaz.
// Sıra kullanıcı kararı: Tamamlanan EN SONA.
export const SEKMELER = [
  { key: "yeni", label: "Yeni", renk: "yeni", sayac: "yeni", icon: InboxStackIcon },
  { key: "onay", label: "Onay Bekleyen", renk: "onay", sayac: "onayda", icon: HandThumbUpIcon },
  { key: "geciken", label: "Geciken", renk: "geciken", sayac: "gecikti", icon: ExclamationTriangleIcon },
  { key: "yakinda", label: "Yakındakiler", renk: "yaklasan", sayac: "yaklasan", icon: ClockIcon },
  { key: "tamamlanan", label: "Tamamlanan", renk: "tamamlanan", sayac: "tamamlanan", icon: CheckCircleIcon },
];

// Birim Havuzu bir statü değil KAPSAM sekmesidir (başka bir kümeye bakar) —
// diğerlerinden dikey çizgiyle ayrılır ve izin yoksa hiç çıkmaz.
export const HAVUZ_SEKMESI = {
  key: "havuz",
  label: "Birim Havuzu",
  renk: "havuz",
  icon: UserGroupIcon,
  kapsamCipi: true,
};

// Şerit havuzu — dört kart, hep bu öncelik sırasında. Aktif sekmenin karşılığı
// olan kart ÇIKARILIR (solda tam listesi zaten açık), kalan ilk ÜÇÜ çizilir.
//   Yeni sekmesi      → gecikenler · onay bekleyenler · yakındakiler
//   Onay sekmesi      → gecikenler · yakındakiler · yeni
//   Geciken sekmesi   → onay bekleyenler · yakındakiler · yeni
//   Yakında sekmesi   → gecikenler · onay bekleyenler · yeni
//   Tamamlanan/Havuz  → gecikenler · onay bekleyenler · yakındakiler
const SERIT_HAVUZU = ["gecikti", "onayda", "yakinda", "yeni"];
const SEKME_KARTI = {
  yeni: "yeni",
  onay: "onayda",
  geciken: "gecikti",
  yakinda: "yakinda",
};

export const SIRALAMALAR = [
  { key: "aciliyet", label: "Aciliyet" },
  { key: "termin", label: "Teslim tarihi" },
  { key: "yeni", label: "En yeni" },
];

export const BOS_FILTRE = {
  dateFrom: "",
  dateTo: "",
  priority: [],
  hasApplication: "",
  completedWindow: "7",
  dueFrom: "",
  dueTo: "",
};

export function etkinFiltreSayisi(f) {
  let n = 0;
  if (f.dateFrom) n += 1;
  if (f.dateTo) n += 1;
  if (f.dueFrom) n += 1;
  if (f.dueTo) n += 1;
  if (Array.isArray(f.priority) && f.priority.length) n += 1;
  if (f.hasApplication) n += 1;
  if (f.completedWindow && f.completedWindow !== "7") n += 1;
  return n;
}

function filtreParametreleri(f, { tamamlananGorunumu }) {
  const p = {};
  if (f.dateFrom) p.created_from = f.dateFrom;
  if (f.dateTo) p.created_to = f.dateTo;
  if (f.dueFrom) p.due_from = f.dueFrom;
  if (f.dueTo) p.due_to = f.dueTo;
  if (Array.isArray(f.priority) && f.priority.length) p.priority = f.priority.join(",");
  if (f.hasApplication) p.has_application = f.hasApplication;
  if (tamamlananGorunumu && f.completedWindow) p.completed_window = f.completedWindow;
  return p;
}

function sorguParametreleri({ sekme, scope, poolScope, q, filtreler, page, sort }) {
  const ortak = {
    sort,
    page,
    page_size: PAGE_SIZE,
    ...(q ? { q } : {}),
    ...filtreParametreleri(filtreler, { tamamlananGorunumu: sekme === "tamamlanan" }),
  };
  // Birim Havuzu bir statü değil KAPSAM sekmesi: kendi kümesine bakar.
  if (sekme === "havuz") return { scope: poolScope, status: ACIK_STATULER, ...ortak };
  return { scope, kume: sekme, ...ortak };
}

function useDebounce(value, delay = 350) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

/**
 * @param {string}  title
 * @param {string}  accent            "ata" | "bana"
 * @param {string}  scope             ana kapsam ("created"|"all"|"assigned")
 * @param {string?} poolScope         verilirse "Birim Havuzu" sekmesi açılır
 * @param {func?}   railKartlari      ({scope, poolScope}) => {gecikti,onayda,yakinda,yeni}
 * @param {string}  tarafGoster       "atanan" | "veren" — satırda kim yazacak
 * @param {func?}   renderCardActions (task, {tazele, havuzda}) => JSX
 */
export default function GorevListeIskeleti({
  title,
  accent = "ata",
  scope,
  poolScope = null,
  infoTitle,
  infoContent = null,
  infoWide = false,
  searchPlaceholder = "Ara…",
  renderFilters = null,
  renderHeaderActions = null,
  renderCardActions = null,
  railKartlari = null,
  tarafGoster = "atanan",
  bosMetin = null,
  tazeleRef = null,
  ustPanel = null,
}) {
  const dispatch = useDispatch();

  const ilkSekme = scope ? "yeni" : "havuz";
  const [sekme, setSekme] = useState(ilkSekme);
  const [sort, setSort] = useState("aciliyet");
  const [q, setQ] = useState("");
  const [filtreler, setFiltreler] = useState(BOS_FILTRE);
  const [page, setPage] = useState(1);

  const aramaDebounced = useDebounce(q, 350);
  const havuzda = sekme === "havuz";

  // İzin değişirse geçerli bir sekmeye düş.
  useEffect(() => {
    if (havuzda && !poolScope && scope) setSekme("yeni");
    if (!havuzda && !scope && poolScope) setSekme("havuz");
  }, [havuzda, poolScope, scope]);

  useEffect(() => {
    setPage(1);
  }, [sekme, sort, aramaDebounced, filtreler]);

  const params = useMemo(
    () => sorguParametreleri({ sekme, scope, poolScope, q: aramaDebounced, filtreler, page, sort }),
    [sekme, scope, poolScope, aramaDebounced, filtreler, page, sort]
  );

  const listKey = useMemo(
    () => `gorev:${accent}:${JSON.stringify(params)}`,
    [accent, params]
  );

  const list = useSelector(selectTaskList(listKey));
  const sayaclar = useSelector(selectTaskCounters(scope || "-"));

  // Listenin uyguladığı DARALTMA (arama + filtreler). Üç yer aynı daraltmayı
  // kullanır: liste, sekme sayaçları ve şerit kartları. Böylece "Geciken 7"
  // yazan sekme ile şeritteki rozet ve listedeki satır sayısı çelişmez.
  const daraltma = useMemo(
    () => ({
      ...(aramaDebounced ? { q: aramaDebounced } : {}),
      ...filtreParametreleri(filtreler, { tamamlananGorunumu: false }),
    }),
    [aramaDebounced, filtreler]
  );

  const tazele = useCallback(() => {
    if (!params.scope) return;
    dispatch(fetchTasksThunk({ listKey, params }));
    if (scope) {
      dispatch(
        fetchCountersThunk({
          scope,
          params: {
            ...daraltma,
            ...(filtreler.completedWindow
              ? { completed_window: filtreler.completedWindow }
              : {}),
          },
        })
      );
    }
  }, [dispatch, listKey, params, scope, daraltma, filtreler.completedWindow]);

  useEffect(() => {
    tazele();
  }, [tazele]);

  useEffect(() => {
    if (tazeleRef) tazeleRef.current = tazele;
  }, [tazele, tazeleRef]);

  const yamala = useCallback((yama) => {
    setFiltreler((onceki) => ({ ...onceki, ...yama }));
  }, []);

  const filtreleriTemizle = useCallback(() => setFiltreler(BOS_FILTRE), []);
  const filtreSayisi = etkinFiltreSayisi(filtreler);

  // ── Başlık barı yüksekliği → şeridin yapışma noktası ────────────────
  // Şerit "başlık barının altına girmesin, sayfayla kaymasın" isteniyor.
  // Bar yüksekliği içeriğe (mobilde iki satır sekme) göre değişiyor, o yüzden
  // ölçülüp CSS değişkenine yazılır.
  const barRef = useRef(null);
  const [barY, setBarY] = useState(0);
  useEffect(() => {
    const el = barRef.current;
    if (!el) return undefined;
    setBarY(el.offsetHeight);
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(() => setBarY(el.offsetHeight));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  // Sekme listesi izinden türer: ana kapsam yoksa yalnız havuz kalır.
  const sekmeler = useMemo(() => {
    const s = scope ? [...SEKMELER] : [];
    if (poolScope) s.push(HAVUZ_SEKMESI);
    return s;
  }, [scope, poolScope]);

  // Şerit: aktif sekmenin kartı havuzdan ÇIKAR, kalan ilk üçü çizilir.
  const kartlar = useMemo(() => {
    const sozluk = typeof railKartlari === "function" ? railKartlari({ scope, poolScope }) : null;
    if (!sozluk) return null;
    const dusen = SEKME_KARTI[sekme];
    return SERIT_HAVUZU.filter((k) => k !== dusen)
      .slice(0, 3)
      .map((k) => sozluk[k])
      .filter(Boolean)
      .map((kart) => ({ ...kart, params: { ...kart.params, ...daraltma } }));
  }, [railKartlari, scope, poolScope, sekme, daraltma]);

  const seritTumu = useCallback((kart) => {
    if (kart.sekme) setSekme(kart.sekme);
    if (kart.sort) setSort(kart.sort);
  }, []);

  const bos = typeof bosMetin === "function" ? bosMetin(sekme) : "Bu listede iş yok.";

  return (
    <div
      className={`gk-page gk-page--${accent}`}
      style={barY ? { "--gk-bar-h": `${barY}px` } : undefined}
    >
      <PageHeader
        stickyRef={barRef}
        title={title}
        infoTitle={infoTitle || title}
        infoContent={infoContent}
        infoWide={infoWide}
        className="gk-header--akan"
        tabs={
          sekmeler.length > 1 ? (
            <div className="applications-tabs" role="tablist" aria-label="Talep listeleri">
              {sekmeler.map((s) => {
                const aktif = s.key === sekme;
                const sayi = s.sayac ? sayaclar?.[s.sayac] : undefined;
                const Icon = s.icon;
                return (
                  <button
                    key={s.key}
                    type="button"
                    role="tab"
                    aria-selected={aktif}
                    className={[
                      "applications-tab gk-tab-renkli",
                      `gk-tab--${s.renk}`,
                      s.kapsamCipi ? "gk-tab--kapsam" : "",
                      aktif ? "active" : "",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                    onClick={() => setSekme(s.key)}
                  >
                    <Icon className="applications-tab-icon" />
                    <span className="applications-tab-label">{s.label}</span>
                    {typeof sayi === "number" && (
                      <span className="applications-tab-count">{sayi}</span>
                    )}
                  </button>
                );
              })}
            </div>
          ) : null
        }
      >
        {/* Araç sırası kullanıcı kararı: arama → yeni görev → filtre → bilgi
            (bilgi PageHeader tarafından en sona otomatik eklenir). */}
        <SearchBox value={q} onChange={setQ} placeholder={searchPlaceholder} />

        {renderHeaderActions ? renderHeaderActions({ tazele }) : null}

        {renderFilters ? (
          <FilterSheet
            activeCount={filtreSayisi}
            onClear={filtreleriTemizle}
            title="Filtreler"
            label="Filtreler"
          >
            {/* FAZ-97 madde 7 — SIRALAMA ARTIK BURADA.
                Kullanıcı: "bu sayfada aciliyet sıralaması varya, daha doğrusu
                sıralama kısmı; bunu filtrelemenin içine al, yer kaplamasın."
                Eskiden başlık barının ALTINDA tam bir satır (`.gk-kumanda`)
                yalnızca bu seçici için duruyordu; telefonda çip şeridiyle
                liste arasına girip ~44px yiyordu.
                Filtre ROZETİ sıralamayı SAYMAZ: sıralama bir süzgeç değil,
                düzendir — "3 filtre var" derken biri sıralama olamaz. */}
            <label className="gk-sirala gk-sirala--filtre">
              <span>Sırala</span>
              <select value={sort} onChange={(e) => setSort(e.target.value)}>
                {SIRALAMALAR.map((s) => (
                  <option key={s.key} value={s.key}>{s.label}</option>
                ))}
              </select>
            </label>
            {renderFilters({ filtreler, yamala, gorunum: sekme })}
          </FilterSheet>
        ) : null}
      </PageHeader>

      {ustPanel}

      <div className="gk-triyaj">
        <main className="gk-akis">
          {list.loading && <EmptyState>Yükleniyor…</EmptyState>}
          {!list.loading && list.error && (
            <EmptyState>Liste alınamadı. Sayfayı yenileyin.</EmptyState>
          )}
          {!list.loading && !list.error && list.items.length === 0 && (
            <EmptyState>{bos}</EmptyState>
          )}

          {/* eslint-disable-next-line jsx-a11y/no-redundant-roles --
              Safari, list-style:none uygulanan <ul>'de liste semantiğini
              DÜŞÜRÜYOR; role="list" bilinen ve gerekli düzeltmedir. */}
          <ul className="gk-satirlar" role="list">
            {list.items.map((task) => (
              <GorevSatiri
                key={task.id}
                task={task}
                tarafGoster={tarafGoster}
                aksiyon={
                  renderCardActions ? renderCardActions(task, { tazele, havuzda }) : null
                }
              />
            ))}
          </ul>

          {!list.loading && list.count > 0 && (
            <Pagination
              page={page}
              totalCount={list.count}
              pageSize={PAGE_SIZE}
              shownCount={list.items.length}
              onChange={setPage}
            />
          )}
        </main>

        {kartlar && kartlar.length ? (
          <GorevDikkatSeridi
            kartlar={kartlar}
            onTumu={seritTumu}
            tarafGoster={tarafGoster}
          />
        ) : null}
      </div>
    </div>
  );
}
